import { createFileRoute } from '@tanstack/react-router';
import { seoHead } from '../../utility/head';
import { KbPage, kbSeo } from '../../components/KbPage';

export const Route = createFileRoute('/kb/a')({
  component: () => <KbPage variant="a" />,
  ssr: true,
  loader: ({ location }) => ({
    pathname: location.pathname,
    seo: kbSeo('a'),
  }),
  // Paid, noindex landing page: strip the canonical seoHead sets (it would
  // contradict noindex) and add robots directly.
  head: ({ loaderData }) => {
    const base = seoHead({ loaderData });

    return {
      ...base,
      meta: [...base.meta, { name: 'robots', content: 'noindex, follow' }],
      links: base.links.filter((link) => link.rel !== 'canonical'),
    };
  },
});
